module.exports = __webpack_public_path__ + "static/media/omvag.0ae846e2.mp3";